import ComplianceTracking from 'modules/compliance/compliance-tracking/Main';
import ComplianceWrapper from 'modules/compliance/components/ComplianceWrapper';
// import UserSecurityPage from 'modules/home/manage-clients/dashboard/usersettings/UserSecurityPage';

const ComplianceRoutes = (): any => ({
  path: '',
  element: <ComplianceWrapper />,
  children: [
    {
      path: 'compliance-tracking',
      element: <ComplianceTracking />,
    },
  ],
});

export default ComplianceRoutes;
